module.exports = __webpack_public_path__ + "img/logo.b28bf82b.png";